import { Modal } from 'antd'
import i18next from 'i18next'
import { action, computed, makeObservable, observable } from 'mobx'

import { IRootStore } from 'store/types'
import { getSharedKey } from 'utils/helpers/i18n/getKeys'
import { colors } from 'shared/constants/values'

import { OfferDTO, UserModuleKeys } from '../../types'
import { OfferApiStore } from './OfferApiStore'

const getApiKey = (key: string) => `${UserModuleKeys.api}.${key}`
export class OfferUiStore {
  @observable offers: OfferDTO[] = []

  @observable modalVisible: boolean = false
  @observable apiStore = new OfferApiStore(this)
  @observable loading = false

  constructor(private readonly rootStore: IRootStore) {
    makeObservable(this)
  }

  @action
  setModalVisible = (value: boolean) => {
    this.modalVisible = value
  }

  @computed
  get linksForOfferModal() {
    return this.offersForSign
      .map((offer) => {
        return [offer.offer, offer.application, offer.tariffs, offer.static]
      })
      .flat()
  }

  @computed
  get linksForRegistration() {
    return this.offers
      .map((offer) => {
        return [offer.offer, offer.application, offer.tariffs, offer.static]
      })
      .flat()
  }

  @computed
  get btnTitles() {
    return [i18next.t(getSharedKey('next')), i18next.t(getSharedKey('next')), i18next.t(getSharedKey('cancel'))]
  }

  @computed
  get offersForSign() {
    return this.offers.filter((offer) => offer.signedVersion < offer.lastVersion)
  }

  @computed
  get needSignOffer() {
    let needSignOffer = false
    this.offers.forEach((offer) => {
      if (offer.signedVersion < offer.lastVersion) {
        needSignOffer = true
      }
    })
    return needSignOffer
  }

  @action
  setOffers = (offers: OfferDTO[]) => {
    this.offers = offers
  }

  @action
  setLoading = (value: boolean) => {
    this.loading = value
  }

  @action
  checkOfferVersion = async () => {
    await this.apiStore.getOfferVersion()
    if (this.rootStore.appStore.hasEntity && this.rootStore.appStore.user.authenticated) {
      if (!this.modalVisible && this.needSignOffer) {
        Modal.info({
          title: i18next.t(getApiKey('Вышла новая версия оферты')),
          content: i18next.t(getApiKey('Для продолжения работы с приложением')),
          onOk: () => this.setModalVisible(true),
          okButtonProps: { style: { backgroundColor: colors.corp } },
        })
      }
    }
  }
}
